// removed by extract-text-webpack-plugin
module.exports = {"tabs":"theme__tabs___2lGJI","navigation":"theme__navigation___2N9WO","label":"theme__label___3A-Tl","active":"theme__active___2SLiK","disabled":"theme__disabled___1mq-I","hidden":"theme__hidden___1XZZy","withIcon":"theme__withIcon___pi4k-","withText":"theme__withText___2-Su2","icon":"theme__icon___wI5gE","pointer":"theme__pointer___pWCM7","tab":"theme__tab___2YMGw","fixed":"theme__fixed___3dgXb","inverse":"theme__inverse___x1bCH"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/tabs/theme.scss
// module id = 1044
// module chunks = 0